export default __webpack_public_path__ + "static/media/devis_template.4196e4ef.pdf";